import { render, staticRenderFns } from "./ReservaRuta.vue?vue&type=template&id=7c906219&scoped=true&"
import script from "./ReservaRuta.vue?vue&type=script&lang=ts&"
export * from "./ReservaRuta.vue?vue&type=script&lang=ts&"
import style0 from "./ReservaRuta.vue?vue&type=style&index=0&id=7c906219&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c906219",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
